<template>
    <!--  <div style="margin-top:0px;" :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'">-->
    <div style="margin-top:0px;" :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'">
        <Header/>
        <div
            :class="$i18n.locale=='العربية'?'FrameWork__PageWrapper-v8gq48-13 eRmiUC':'FrameWork__PageWrapper-v8gq48-13 obiMX'" :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important; '">
            <section class="style__SpotlightInnerWrap-sc-1qapdh8-0 kKgHVc">
                <div class="spotlight" :style="$i18n.locale == 'العربية' ?'float:right;width:100%;':'float:left;width:100%;'">
                    <div class="style__SpotlightItemStyled-vo40go-0 cDscbW">
                        <figure>
                            <div class=" gatsby-image-wrapper" style="position:relative;overflow:hidden">
                                <div aria-hidden="true" style="width:100%;padding-bottom:49.5%"></div>

                                <picture v-if="this.pagedata"><img
                                              :src="this.serverurl+'/public/pagebanners/'+pagedata.pagebanner"
                                              alt=""
                                              style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>

                                </picture>


                               <!--            <video style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"-->
<!--                   v-if="this.pagedata && this.pagedata.id==51"  width="100%"-->
<!--                   height="100%" autoplay loop>-->
<!--                <source :src="this.serverurl+'/public/pagebanners/scalping.webm'" type="video/webm" style="position:absolute;top:0;left:0;opacity:1;min-width:100%;min-height:100%;object-fit:cover;object-position:center" />-->
<!--                Your browser does not support the video tag.-->
<!--            </video>-->

                            </div>
                        </figure>
                        <div class="spotlight__info" :style="$i18n.locale == 'العربية' ?'float:right;width:100%;padding-left:8%;padding-right:8%':'float:left;margin-left:3%;width:100%;padding-left:8%;padding-right:8%'">
                            <div class="react-reveal"
                                 style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">
                                <div class="style__SectionTitleStyled-d40vxv-0 kcvceY" :style="$i18n.locale == 'العربية' ?'float:right;margin-right:3%;width: 50%;':'float:left;margin-left:3%;width: 50%;'">
                                    <h2 v-if="pagedata" :style="$i18n.locale == 'العربية' ? 'text-align: right;font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important;'">
                                        {{
$i18n.locale == 'en' ? pagedata.page_entitle : $i18n.locale == 'العربية' ? pagedata.page_artitle : $i18n.locale == '中文' ? pagedata.page_chtitle :$i18n.locale=='Русский'?pagedata.page_rutitle: pagedata.page_frtitle
                                        }}</h2>
                                        <br />

<h3 v-if="pagedata" :style="$i18n.locale == 'العربية' ?'text-align: right;font-size: 23px!important;color:#ffffff;font-family: Cairo,sans-serif !important;margin-right:2%;':'font-size: 23px!important;color:#ffffff;font-family: Comfortaa!important;margin-left:2%'">
                                        {{
                                            $i18n.locale == 'en' ? pagedata.en_subtitle : $i18n.locale == 'العربية' ? pagedata.ar_subtitle : $i18n.locale == '中文' ? pagedata.ch_subtitle :$i18n.locale=='Русский'?pagedata.ru_subtitle: pagedata.fr_subtitle
                                        }}</h3>
                                </div>
                            </div>
                                                       <div class="btn_wrap" :style="$i18n.locale == 'العربية' ?'width:100%;float:right!important;margin-right:3%!important':'width:100%;float:left;margin-left:3%!important'">

                                <div class="react-reveal" :style="$i18n.locale == 'العربية' ?'float:right;animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;':'animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;'">
                                    <div class="style__ButtonWrap-kitu94-0 hqzysg" style="width: 100%!important;text-align: center!important;"><a style=""
                                        href="https://marketequityinc.com/custom/demoaccountlinks.php" target="_blank"
                                        rel="noopener noreferrer"><span>
                                        {{
                                         $i18n.locale == 'en' ? 'Open Demo Account' : $i18n.locale == 'العربية' ? 'فتح حساب تجريبي' : $i18n.locale == '中文' ? '开设模拟账户':$i18n.locale=='Русский'?'Открыть демо-аккаунт' : 'Ouvrir un compte Dé'

                                        }}

                                        </span></a></div>
                                </div>
                                 <div class="react-reveal" :style="$i18n.locale == 'العربية' ?'float:right;animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;':'animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;'">
                                    <div class="style__ButtonWrap-kitu94-0 hqzysg" style="width: 100%!important;text-align: center!important;"><a style=""
                                        href="https://marketequityinc.com/custom/liveaccountlinks.php" target="_blank"
                                        rel="noopener noreferrer"><span>
                                            {{
                                            $i18n.locale == 'en' ? 'Open Live Account' : $i18n.locale == 'العربية' ? 'فتح حساب حقيقي' : $i18n.locale == '中文' ? '开设真实账户':$i18n.locale=='Русский'?'Открыть реальный аккаунт': 'Ouvrir un compte Réel'
                                }}
                                        </span></a></div>
                                </div>
                                <div v-if="pagedata.layout==4" class="react-reveal"
                                     style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 360ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">
                                    <div class="style__ButtonWrap-kitu94-0 hqzysg"><a class="no-border"
                                                                                      href="https://www.linkedin.com/company/market-equity-inc/?originalSubdomain=in"
                                                                                      target="_blank"
                                                                                      rel="noopener noreferrer">
                                        <div class=" gatsby-image-wrapper"
                                             style="position: relative; overflow: hidden; display: inline-block; width: 100px; height: 30px;">
                                            <picture><img loading="lazy" width="100" height="30"
                                                          src="https://dev.marketequityinc.com/public/public/follow-linkedin.jpg"
                                                          alt="Follow us on Linked In"
                                                          style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>
                                            </picture>
                                        </div>
                                    </a></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section>


                <div class="FrameWork__ContainerFluidStyled-v8gq48-1 kNCxBo">

                    <div class="FrameWork__ColSm-v8gq48-3 dIoETn">

                        <!-- The Modal -->

                        <div class="react-reveal"
                             style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">
                            <div class="FrameWork__ContentData-v8gq48-10 ZBsdR"
                                 :style="$i18n.locale == 'العربية' ?'text-align: right':'text-align: left'">
                                <div class="FrameWork__Row-v8gq48-2 VIUMD" style="margin-top: 3%;">
                                    <div class="FrameWork__ColSm-v8gq48-3 dIoETn"
                                         style="padding-left:10%;padding-right:10%">



                                       <div class="panel-group" id="accordionfaq" role="tablist" aria-multiselectable="true"
                             :style="$i18n.locale=='العربية'?'direction:rtl':'direction:left'">
                            <div v-for="promotionscat in promotionsdata" v-bind:key="promotionscat.id"
                                 class="panel panel-default">
                                <div :style="$i18n.locale=='العربية'?'float:right;width:100%;text-align:right':''"
                                     class="panel-heading" role="tab" id="heading">
                                    <h4 class="panel-title">
                                        <a role="button" data-toggle="collapse" data-parent="#accordionfaq"
                                           :href="'#collapse'+promotionscat.id"
                                           :aria-expanded="promotionscat.id==1?true:false"
                                           aria-controls="collapseOne">
                                            {{ promotionscat.title }}
                                        </a>
                                    </h4>
                                </div>
                                <div :id="'collapse'+promotionscat.id"
                                     :class="promotionscat.id==1?'panel-collapse in collapse show':'panel-collapse in collapse'"
                                     role="tabpanel" aria-labelledby="headingOne">
                                    <div class="table-responsive panel-body">
                                        <table class="table  table-hover">


                                            <tbody v-for="promotionsdetails in promotionsdetailsdata"
                                                   v-bind:key="promotionsdetails.id">

                                            <tr v-if="promotionscat.id==promotionsdetails.promotioncat_id" >

                                                <td  v-html="$i18n.locale == 'en' ? promotionsdetails.contenten : $i18n.locale == 'العربية' ? promotionsdetails.contentar : $i18n.locale == '中文' ? promotionsdetails.contentch : promotionsdetails.contentfr">{{ $i18n.locale == 'en' ? promotionsdetails.contenten : $i18n.locale == 'العربية' ? promotionsdetails.contentar : $i18n.locale == '中文' ? promotionsdetails.contentch : promotionsdetails.contentfr }}



                                      </td> </tr>
<tr v-if="promotionscat.id==promotionsdetails.promotioncat_id" style="background-color:#ffffff;">
<td style="max-width: 450px!important;min-width:450px!important;">
     <div style="max-width: 450px!important;min-width:450px!important;">

                                        <form class="style__FormWrap-sc-1iaf0iy-2 jZQfFQ" v-on:submit.prevent="submitForm" >
                                            <div>
                                                <input :style="$i18n.locale == 'العربية' ? 'text-align: right;' :''" v-model="name" name="name" type="text" autocomplete="nope"
                                                        placeholder="Name" value=""><label :style="$i18n.locale == 'العربية' ? 'right:0;' :'left:0'">
                                                {{
                                                    $i18n.locale == 'en' ? 'Name' : $i18n.locale == 'العربية' ? 'الإسم' : $i18n.locale == '中文' ? '名字':$i18n.locale=='Русский'?'Имя' : 'Nom'
                                                }}
                                            </label>
                                                <!--                                                <div class="error-message">Please enter your name</div>-->
                                            </div>
                                            <div><input v-model="email" name="email" type="email" autocomplete="nope"
                                                        placeholder="Email" value=""><label :style="$i18n.locale == 'العربية' ? 'right:0;' :'left:0'">
                                                {{
                                                    $i18n.locale == 'en' ? 'Email' : $i18n.locale == 'العربية' ? 'البريد الإلكتروني' : $i18n.locale == '中文' ? '邮箱' :$i18n.locale=='Русский'?'Электронное письмо': 'Adresse email'
                                                }}
                                            </label></div>
                                            <div><input v-model="subject" name="subject" type="text" autocomplete="nope"
                                                        placeholder="Subject" value=""><label :style="$i18n.locale == 'العربية' ? 'right:0;' :'left:0'">
                                                {{
                                                    $i18n.locale == 'en' ? 'Subject' : $i18n.locale == 'العربية' ? 'موضوع' : $i18n.locale == '中文' ? '主题' :$i18n.locale=='Русский'?'Предмет': 'Sujet'
                                                }}

                                            </label></div>
                                            <div><textarea v-model="message" name="message" autocomplete="nope"
                                                           placeholder="Message"></textarea><label :style="$i18n.locale == 'العربية' ? 'right:0;' :'left:0'">
                                                {{
                                                    $i18n.locale == 'en' ? 'Message' : $i18n.locale == 'العربية' ? 'الرسالة' : $i18n.locale == '中文' ? '信息':$i18n.locale=='Русский'?'Сообщение' : 'Message'
                                                }}
                                            </label></div>
<!--                                            <div class="recaptcha">-->
<!--                                                <div>-->
<!--                                                    <div style="width: 304px; height: 78px;">-->
<!--                                                        <div>-->
<!--                                                            <iframe-->
<!--                                                                src="https://www.google.com/recaptcha/api2/anchor?ar=1&amp;k=6LeMvsUZAAAAAM554vVgQ4iGCmF9MwNdvKmbgCr_&amp;co=aHR0cHM6Ly9tYXJrZXRlcXVpdHkuY29tOjQ0Mw..&amp;hl=en&amp;type=image&amp;v=qc5B-qjP0QEimFYUxcpWJy5B&amp;theme=light&amp;size=normal&amp;badge=bottomright&amp;cb=8w6d7q21t2qg"-->
<!--                                                                role="presentation" name="a-o0bfmgpolmg" scrolling="no"-->
<!--                                                                sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-top-navigation allow-modals allow-popups-to-escape-sandbox allow-storage-access-by-user-activation"-->
<!--                                                                width="304" height="78" frameborder="0"></iframe>-->
<!--                                                        </div>-->
<!--                                                        <textarea id="g-recaptcha-response" name="g-recaptcha-response"-->
<!--                                                                  class="g-recaptcha-response"-->
<!--                                                                  style="width: 250px; height: 40px; border: 1px solid rgb(193, 193, 193); margin: 10px 25px; padding: 0px; resize: none; display: none;"></textarea>-->
<!--                                                    </div>-->
<!--                                                    <iframe style="display: none;"></iframe>-->
<!--                                                </div>-->
<!--                                            </div>-->
                                            <button :style="$i18n.locale == 'العربية' ? 'right:0;' :'left:0'" type="submit" class="style__ButtonWrap-sc-1i4p4w8-0 UOTGs"><span
                                                class="caption">
                                                {{
                                                    $i18n.locale == 'en' ? 'Submit Request' : $i18n.locale == 'العربية' ? 'قدم' : $i18n.locale == '中文' ? '提交':$i18n.locale=='Русский'?'Отправить запрос' : 'Envoyer votre demande'
                                                }}
                                                </span></button>
                                        </form>
                                        <br /> <br /> <br /> <br />

                                        <p align="center" style="color:green" v-if="emailnotify"> {{ emailnotify }}</p>
                                    </div>
</td>
</tr>


                                    </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>


                        </div>
                                </div>
                            </div>


                    </div>

                </div>
  </div>
                </div>
            </section>


            <iframe style="display: none; position: fixed; border: 0px none; overflow: hidden;"
                    src="https://marketequity.ladesk.com/scripts/generateWidget.php?v=5.21.17.15&amp;t=1607084151&amp;cwid=e00b30c6&amp;cwrt=C&amp;cwt=chat&amp;pt=Home%20page%20-%20Market%20Equity%20Inc%20-%20Leading%20Trading%20Service%20Provider&amp;ref=https%3A%2F%2Fmarketequity.com%2Fen%2F%23speciality"
                    allowfullscreen="true" allow="microphone; camera" tabindex="-1" class="i-embedded-chat"
                    id="icb_e00b30c6_305"></iframe>


            <Footer/>
        </div>

    </div>

</template>

<script>
import Header from '@/components/header.vue'
import Footer from '@/components/footer.vue'

export default {
    name: 'webinar',
    data() {
        return {

            pagedata: '',
            pageblocksdata: '',
            contactdata: '',
            contractcat: '',
            contractspecdetails: '',
            pagenameroute: '',
            upcomingwebinar: '',
            webinarsprevious: '',
            registeremail: '',
            registername: '',
            registermobile: '',
            registercountry: '965',
            prevregistercountry: '965',
            registerpassword: '',

            prevregisteremail: '',
            prevregistername: '',
            prevregistermobile: '',
            prevregisterpassword: '',
            signinemail: '',
            signinpassword: '',
            subscribeerror: null,
            exampleModalCenter: '',
            prevvideoregister: '',
            webinarid: '',
            prevwebinarid: '',
            successregiter: '',
            errorregiter: '',
            prevuserlogin: '',
            prevpassword: '',
            prevsigninemail: '',
            prevsiginpassword: '',
            prevvideosigninflag: false,
            langchange: '',
            webinarpageregisterflag: false,
            webregisteremail: '',
            webregistermobile: '',
            webregistername: '',
            webregisterlanuage: '',
            registererror: null,
            registercountryname: 'Kuwait',
            currencydata: '',
            promotionsdata: '',
            crossesdata: '',
            showmodal:false,
            canview:0,
            accordianid:'',
            noregisterflag:0,
            currentdate: '',
            dayname: '',
            daynamear: '',
            promotionsdetailsdata:''



        }
    },
    components: {
        Header,
        Footer
    },
    mounted() {

        let recaptchaScript = document.createElement('script')
        recaptchaScript.setAttribute('src', 'https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/js/bootstrap.min.js')
        document.head.appendChild(recaptchaScript)
    },
    beforeMount() {
        if (document.cookie != "") {
            var cookies = document.cookie.split(";");
            for (var i = 0; i < cookies.length; i++) {
                var cookie = cookies[i].trim().split("=");

                if (cookie[0] == 'registername') {
                    this.registername = cookie[1];
                }
                if (cookie[0] == 'registermobile') {
                    this.registermobile = cookie[1];
                }
                if (cookie[0] == 'registeremail') {
                    this.registeremail = cookie[1];
                }
                if (cookie[0] == 'registercountry') {
                    this.registercountry = cookie[1];
                }
            }

        }
        if (localStorage.getItem('prevuserlogin') == 1) {
            this.prevuserlogin = 1;
        }
        if (localStorage.getItem('webinarpageregisterflag')) {
            this.webinarpageregisterflag = true;
            // alert(this.webinarpageregisterflag)
        }

        var pathvalues = (this.$route.path).split("/");


        if (pathvalues[1] == 'ar') {
            this.$i18n.locale = 'العربية';
        }
        if (pathvalues[1] == 'ch') {
            this.$i18n.locale = '中文';
        }
        if (pathvalues[1] == 'fr') {
            this.$i18n.locale = 'Français';
        }
        this.langchange = this.$i18n.locale;
        this.pagenameroute = pathvalues[4];
        this.loadpagedata(pathvalues[2]);

    },

    methods: {
        setaccordianid(accordionidvar,noregisterflag){
            this.accordianid=accordionidvar;
            this.noregisterflag=noregisterflag
            if(this.webinarpageregisterflag=='false') {
                if (this.noregisterflag == 0) {
                    this.canview = 1;

                } else {
                    this.canview = 0;
                }
            }
            return;
        },
        setcrossesaccordianid(accordionidvar,noregisterflag){
            this.accordianid=accordionidvar;
            this.noregisterflag=noregisterflag
            if(this.webinarpageregisterflag=='false') {
                if (this.noregisterflag == 0) {
                    this.canview = 1;

                } else {
                    this.canview = 0;
                }
            }
            return;
        },
        showsignin(){
            document.getElementById("signin").style.display = "block";
            document.getElementById("register").style.display = "none";

        },
        showregister(){
            document.getElementById("signin").style.display = "none";
            document.getElementById("register").style.display = "block";

        },

        onChange(event) {
           // var optionValue = event.target.value;
           // var optionText = event.target.options[event.target.options.selectedIndex].text;
            this.registercountryname=event.target.options[event.target.options.selectedIndex].text;
           // alert( this.registercountryname)

        },



        register(langfl) {
            if (!this.registeremail || !this.registermobile || !this.registername) {
                this.registererror = "الرجاء تعبئة جميع البيانات";
                return false;
            }
            this.successregiter = ""
            if (langfl == 'العربية') {
                langfl = 'ar';
            }

            this.langchange = langfl;

            this.$axios.get("registeranalysis", {
                params: {

                    email: this.registeremail,
                    name: this.registername,
                    language: this.langchange,
                    mobile: this.registercountry + this.registermobile,
                    country:this.registercountryname

                }
            })
                .then(res => {
                    if (res) {
                        console.log(res)

                        if (res.data.code == 200) {
                            //  document.getElementById("salesforceregister").submit();

                            this.webinarpageregisterflag = true;
                           // localStorage.setItem('webinaremail', this.registeremail)

                            document.cookie =
                                "registername=" + this.registername + ";" + 2147483647 + ";path=/";
                            document.cookie =
                                "registeremail=" + this.registeremail + ";" + 2147483647 + ";path=/";
                            document.cookie =
                                "registermobile=" + this.registermobile + ";" + 2147483647 + ";path=/";
                            document.cookie =
                                "registercountry=" + this.registercountry + ";" + 2147483647 + ";path=/";

                            // setCookie("FirstName", this.registername);
                            // setCookie("mobile", webinarmobile);
                            if (this.langchange != 'ar') {
                                this.successregiter = "Thank you for register. Please check your inbox";


                            } else {
                                this.webinarpageregisterflag = true;

                                this.successregiter = "شكرا للتسجيل الرجاء التحقق من بريدك الإلكتروني";
                            }
                            this.registeremail = null;
                            this.registername = null;
                            this.webinarid = null;
                            this.registercountry = '965';

                            this.canview=1;


                        } else {
                            this.errorregiter = "Error with Register. Please Register after some time";

                        }


                    }
                });
        },
        login() {
             this.$axios.get("analysislogin", {
                params: {

                    accountnumber: this.signinemail,
                    email: this.signinpassword,


                }
            })
                .then(res => {
                    if (res) {
                        console.log(res)

                        if (res.data.code == 200) {
                            this.canview=1;
                            return false;
                        } else {
                            this.canview=0;

                            this.errorregiter = "User does not Exist. Please Register";
                            return false;
                        }


                    }
                });
        },
        prevsiginmwebinar() {
            if (!this.prevsigninemail || !this.prevsiginpassword) {
                this.errorregiter = "Please Fill all Fields";

                return false;
            }

            this.$axios.get("prevuserlogin", {
                params: {

                    prevemail: this.prevsigninemail,
                    prevpassword: this.prevsiginpassword,


                }
            })
                .then(res => {
                    if (res) {
                        console.log(res)

                        if (res.data.code == 200) {
                            this.prevuserlogin = 1;
                            localStorage.setItem('prevuserlogin', this.prevuserlogin)
                            this.successregiter = "Thank you for Signin. Now you can watch the videos";
                            return false;
                        } else {
                            this.prevuserlogin = 0;

                            this.errorregiter = "Your Username / Password Wrong";
                            return false;
                        }


                    }
                });
        },

        loadpagedata(pagename) {

            this.$axios.get("loadpagedata", {
                params: {
                    pagename: pagename
                }
            })
                .then(res => {
                    if (res) {
                        console.log(res)
                        this.pagedata = res.data.pagedata[0];
                        this.promotionsdata = res.data.promotionscat;
                        this.promotionsdetailsdata = res.data.promotionsdetails;


                    }
                });


        },
    }
}
</script>

<style>

.rtlclass {
    direction: rtl !important;
    font-family: "Cairo", sans-serif !important;


}

.ltrclass {
    direction: ltr !important;
}

select {
    width: 150px;
    line-height: 49px;
    height: 38px;
    font-size: 22px;
    outline: 0;
    margin-bottom: 15px;
}

.p {
    animation-fill-mode: both;
    animation-duration: 1000ms;
    animation-delay: 0ms;
    animation-iteration-count: 1;
    opacity: 1;
    animation-name: slideInUp;
}


.modal-backdrop {
    opacity: 0.5 !important;
}
#accordionfaq .panel {
    border: none;
    border-radius: 3px;
    box-shadow: none;
    margin-bottom: 0px;
}

#accordionfaq .panel-heading {
    padding: 0;
    border: none;
    border-radius: 3px;
}

#accordionfaq .panel-title a {
    display: block;
    padding: 8px 8px 8px 8px;
    background: #ffffff;
    border: 1px solid #c3c3c3;
    border-radius: 3px;
    font-size: 22px;
    font-weight: bold;
    color: #005060;
    text-shadow: 0px 0px 0px #fff;
    position: relative;

}

#accordionfaq .panel-title a p {
    margin-bottom: 11px !important;
    margin-left: 10px !important;
    margin-right: 10px !important;
}

#accordionfaq .panel-collapse div p {
    margin-bottom: 1px !important;
    margin-left: 1px !important;
    margin-right: 1px !important;

}

#accordionfaq .panel-collapse div {
    background-color: #f1f1f1;
    border-top: 1px solid #c3c3c3;
    border-bottom: 1px solid #c3c3c3;
    border-left: 1px solid #c3c3c3;
    border-right: 1px solid #c3c3c3;
    padding-left: 1px;
    padding-right: 1px;
    padding-top: 1px;
    padding-bottom: 1px;

}


#accordioncurrency .panel {
    border: none;
    border-radius: 3px;
    box-shadow: none;
    margin-bottom: 0px;
}

#accordioncurrency .panel-heading {
    padding: 0;
    border: none;
    border-radius: 3px;
}

#accordioncurrency .panel-title a {
    display: block;
    padding: 8px 8px 8px 8px;
    background: #ffffff;
    border: 1px solid #c3c3c3;
    border-radius: 3px;
    font-size: 22px;
    font-weight: bold;
    color: #005060;
    text-shadow: 0px 0px 0px #fff;
    position: relative;

}

#accordioncurrency .panel-title a p {
    margin-bottom: 11px !important;
    margin-left: 10px !important;
    margin-right: 10px !important;
}

#accordioncurrency .panel-collapse div p {
    margin-bottom: 11px !important;
    margin-left: 10px !important;
    margin-right: 10px !important;

}

#accordioncurrency .panel-collapse div {
    background-color: #f1f1f1;
    border-top: 1px solid #c3c3c3;
    border-bottom: 1px solid #c3c3c3;
    border-left: 1px solid #c3c3c3;
    border-right: 1px solid #c3c3c3;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 10px;
    padding-bottom: 10px;

}
.jZQfFQ div input, .jZQfFQ div .fileHolder, .jZQfFQ div textarea {
  border: none;
    border-bottom-color: currentcolor;
    border-bottom-style: none;
    border-bottom-width: medium;
  border-bottom: 1px solid #707070;
  text-transform: uppercase;
  font-size: 16px;
  margin-bottom: 5px!important;
  height: 50px;
  line-height: 20px!important;
  width: 100%;
  text-align: left;
}

/*#accordionfaq .panel-title a ::before {*/

/*    content: "+";*/
/*    font-family: "Font Awesome 5 Free";*/
/*    width: 25px;*/
/*    height: 25px;*/
/*    line-height: 25px;*/
/*    border-radius: 50%;*/
/*    background: rgb(45, 174, 202) none repeat scroll 0% 0%;*/
/*    font-size: 12px;*/
/*    font-weight: 900;*/
/*    color: #ffffff;*/
/*    text-align: center;*/
/*    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.5);*/
/*    text-shadow: none;*/
/*    position: absolute;*/
/*    top: 8px;*/
/*    right: 15px;*/

/*}*/

.shownone{
    display:none
}


</style>

